export default "__VITE_ASSET__NhiMUais__"